//import createCachedSelector from 're-reselect';

export const defaultPartnerId = 0;

export const DEFAULT_PARTNER = {
  generalData: {},
  addresses: [],
  contactData: {},
  contactMode: {},
  agreesWithPersonalDataUse: false,
  agreesWithPersonalDataUseReadOnly: false,
  fromPartnerQuery: false
};

export const getOfferPartner = (state, partnerId) => state.entities.offerPartners[partnerId] || DEFAULT_PARTNER;

// eslint-disable-next-line
export const getPartnerByUniqueId = (state, uniqueId) => {
  return state.clientData.clients.byUniqueId[uniqueId.replace(/\s/g, "")] || DEFAULT_PARTNER;
};
